var _path, _path2, _path3, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadio1A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 12,
    viewBox: "0 0 72 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26172 6C1.26172 2.96243 3.72415 0.5 6.76172 0.5C9.79928 0.5 12.2617 2.96243 12.2617 6C12.2617 9.03757 9.79928 11.5 6.76172 11.5C3.72415 11.5 1.26172 9.03757 1.26172 6Z",
    fill: "white",
    stroke: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2617 6C41.2617 2.96243 43.7242 0.5 46.7617 0.5C49.7993 0.5 52.2617 2.96243 52.2617 6C52.2617 9.03757 49.7993 11.5 46.7617 11.5C43.7242 11.5 41.2617 9.03757 41.2617 6Z",
    fill: "white",
    stroke: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76172 6C4.76172 4.89543 5.65715 4 6.76172 4C7.86629 4 8.76172 4.89543 8.76172 6C8.76172 7.10457 7.86629 8 6.76172 8C5.65715 8 4.76172 7.10457 4.76172 6Z",
    fill: "#7C7C7C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 2,
    width: 16,
    height: 8,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 2,
    width: 16,
    height: 8,
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio1A);
export default __webpack_public_path__ + "static/media/Radio-1A.31b3bae03b08fde9417543ccaa4804ba.svg";
export { ForwardRef as ReactComponent };